<po-page-list
  p-title="Modulo de Entrada NFs - Fornecedores Oculto"
  [p-actions]="pageActions"
  [p-filter]="filterSettings">

  <po-table
    [p-columns]="columns"
    [p-items]="fornecedoresFiltered"
    [p-actions]="tableActions"
    [p-loading]="loading || loadingMore"
    [p-sort]="true"
    [p-striped]="true"
    [p-height]="tableHeight"
    [p-show-more-disabled]="!hasMore"
    (p-show-more)="carregarMais()">
  </po-table>

</po-page-list>

<po-modal
  #formModal
  [p-title]="editing !== null ? 'Editar Fornecedor' : 'Adicionar Fornecedor'"
  [p-primary-action]="modalPrimaryAction"
  [p-secondary-action]="modalSecondaryAction">

  <div class="po-row" *ngIf="!editing">
    <small class="po-md-12 po-font-text-small">
      Informe CNPJ + Loja de um fornecedor ja cadastrado em SA2. O nome
      sera puxado do cadastro do fornecedor (ou pode ser personalizado abaixo).
    </small>
  </div>

  <div class="po-row">
    <po-input
      class="po-md-9"
      p-label="CNPJ"
      p-placeholder="00.000.000/0000-00"
      [ngModel]="novoCnpj"
      (p-change)="novoCnpj = $event"
      name="novoCnpj"
      [p-mask]="cnpjMask"
      [p-pattern]="cnpjPattern"
      p-error-pattern="CNPJ invalido."
      [p-disabled]="editing ? 'true' : 'false'"
      p-required>
    </po-input>

    <po-input
      class="po-md-3"
      p-label="Loja"
      p-placeholder="0001"
      [ngModel]="novaLoja"
      (p-change)="novaLoja = $event"
      name="novaLoja"
      p-mask="9999"
      p-pattern="^\d{4}$"
      p-error-pattern="Use 4 digitos."
      [p-disabled]="editing ? 'true' : 'false'"
      p-required>
    </po-input>
  </div>

  <div class="po-row">
    <po-input
      class="po-md-12"
      p-label="Fornecedor"
      [p-placeholder]="editing ? 'Nome do Fornecedor' : 'Opcional - se vazio, usa o A2_NOME do SA2'"
      [ngModel]="novoNome"
      (p-change)="novoNome = $event"
      name="novoNome"
      [p-minlength]="3"
      [p-maxlength]="120"
      [p-required]="editing ? 'true' : 'false'">
    </po-input>
  </div>

</po-modal>
